import { useMemo } from 'react';
import { Box, Tab, Tabs } from '@tempmee/react';
import { JobPostingStatus, JobPostingStatusMapper } from '~/domain/PermanentJobs';

interface IJobPostingStatusFilterPanelProps {
  counts: Record<JobPostingStatus, number>;
  initialStatus?: JobPostingStatus;
  onChange(tab: JobPostingStatus): void;
}

export const JobPostingStatusFilterPanel = ({
  counts,
  initialStatus,
  onChange,
}: IJobPostingStatusFilterPanelProps) => {
  const tabs = useMemo(
    () => [
      {
        title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Active),
        value: JobPostingStatus.Active,
        isVisible: true,
        dataCy: 'manage-jobs-tab-active',
      },
      {
        title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Closed),
        value: JobPostingStatus.Closed,
        isVisible: true,
        dataCy: 'manage-jobs-tab-closed',
      },
      {
        title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Suspended),
        value: JobPostingStatus.Suspended,
        isVisible: counts.suspended > 0,
        dataCy: 'manage-jobs-tab-suspended',
      },
      {
        title: `${JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Draft)}s`,
        value: JobPostingStatus.Draft,
        isVisible: true,
        dataCy: 'manage-jobs-tab-drafts',
      },
    ],
    [counts.suspended],
  );

  return (
    <Tabs
      defaultValue={initialStatus ?? JobPostingStatus.Active}
      onChange={(value) => onChange(value as JobPostingStatus)}
      style={{ gap: 16 }}
    >
      {tabs.filter((it) => it.isVisible).map((it) => (
        <Tab key={it.value} value={it.value} data-cy={it.dataCy}>
          <Box
            height="10px"
            width="10px"
            className="rounded-full"
            style={{
              display: 'inline-block',
              marginRight: 6,
              backgroundColor: JobPostingStatusMapper.getColor(it.value),
            }}
          />
          {`${it.title}${counts[it.value] > 0 ? ` (${counts[it.value]})` : ''}`}
        </Tab>
      ))}
    </Tabs>
  );
};
